// extracted by mini-css-extract-plugin
export var root = "ArticleVerticalTile-root-ikp0H";
export var rootArticleMeta = "ArticleVerticalTile-root_articleMeta-kbuI6";
export var rootContent = "ArticleVerticalTile-root_content-dKRYN";
export var rootHeading = "ArticleVerticalTile-root_heading-WatAm";
export var rootImage = "ArticleVerticalTile-root_image-I9DnM";
export var rootLink = "ArticleVerticalTile-root_link-5l1Ba";
export var rootPicture = "ArticleVerticalTile-root_picture--47yO";
export var rootPictureIcon = "ArticleVerticalTile-root_pictureIcon-3yfBT";
export var rootPicturePlaceholder = "ArticleVerticalTile-root_picturePlaceholder-7UpCl";
export var rootText = "ArticleVerticalTile-root_text-j8lOG";